import type { ReactNode } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { QueueAccount } from './QueueAccountsFieldset';

export function QueueAccountIdentity({ connection, platform }: {
  connection: QueueAccount;
  platform: { label: string; icon: ReactNode };
}) {
  const label = connection.display_name || connection.username || platform.label;
  return (
    <>
      <Avatar className="h-10 w-10 shrink-0">
        <AvatarImage src={connection.avatar_url ?? undefined} alt="" className="object-cover" />
        <AvatarFallback>{platform.icon}</AvatarFallback>
      </Avatar>
      <span className="min-w-0 flex-1">
        <span className="block truncate font-medium" title={connection.username || label}>
          {connection.username ? `@${connection.username.replace(/^@/, '')}` : label}
        </span>
        <span className="mt-0.5 block truncate text-sm font-normal text-muted-foreground" title={label}>{label}</span>
      </span>
    </>
  );
}
